import React, { useState, useCallback, useEffect } from "react";
import Swal from "sweetalert2";
import { render } from "react-dom";
import ImageViewer from "react-simple-image-viewer";
import Topbar from "../Topbar/Topbar";
import "./StaffAnalysis.css";
import { Doughnut, Line } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Col, Row } from "react-bootstrap";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { useSelector } from "react-redux";
import axios from "axios";
ChartJS.register(ArcElement, Tooltip, Legend);

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
      display: false,
    },
  },
  tension: 0.4,
  scales: {
    x: { grid: { display: false } },
    y: {
      grid: {
        display: false,
      },
      beginAtZero: true,
    },
  },
};

const dataLine = {
  labels: [
    "APR 01",
    "APR 05",
    "APR 10",
    "APR 15",
    "APR 20",
    "APR 25",
    "APR 30",
  ],
  datasets: [
    {
      label: "Open",
      data: [0, 0, 0, 0, 0, 0, 0],
      borderColor: "green",
      backgroundColor: "rgba(0, 255, 0, 0.2)",
      pointBorderColor: "black",
      pointBackgroundColor: "black",
      borderWidth: 3,
    },
    {
      label: "Solved",
      data: [0, 0, 0, 0, 0, 0, 0],
      borderColor: "blue",
      backgroundColor: "rgba(0, 0, 255, 0.2)",
      pointBorderColor: "black",
      pointBackgroundColor: "black",
      borderWidth: 3,
    },
  ],
};

const optionsLine = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
      display: false,
    },
  },
  tension: 0.4,
  scales: {
    x: { grid: { display: false } },
    y: {
      grid: {
        display: false,
      },
      beginAtZero: true,
    },
  },
};
//graph2
const dataLine1 = {
  labels: [
    "APR 01",
    "APR 05",
    "APR 10",
    "APR 15",
    "APR 20",
    "APR 25",
    "APR 30",
  ],
  datasets: [
    {
      label: "Open",
      data: [0, 0, 0, 0, 0, 0, 0],
      borderColor: "green",
      backgroundColor: "rgba(0, 255, 0, 0.2)",
      pointBorderColor: "black",
      pointBackgroundColor: "black",
      borderWidth: 3,
    },
    {
      label: "Solved",
      data: [0, 0, 0, 0, 0, 0, 0],
      borderColor: "blue",
      backgroundColor: "rgba(0, 0, 255, 0.2)",
      pointBorderColor: "black",
      pointBackgroundColor: "black",
      borderWidth: 3,
    },
  ],
};
const optionsLine1 = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
      display: false,
    },
  },
  tension: 0.4,
  scales: {
    x: { grid: { display: false } },
    y: {
      grid: {
        display: false,
      },
      beginAtZero: true,
    },
  },
};

const dropdownOptions = [
  "All",
  "Complaints",
  "Time Contributions",
  "K M Traveled",
  "Cable Used",
  "Connections",
  "Fiber Team Photos",
  "Network Team Photos",
  "Complaints Photos",
  "Recovery Photos",
];

export default function StaffAnalysis() {
  const [images, setImages] = useState([]);
  const [imagesDelData, setImagesDelData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const staffId = useSelector((state) => state.id);
  const role = useSelector((state) => state.roleName);
  const [staffName, setStaffName] = useState([]);
  //image fetching
  const [overallImages, setOverallImages] = useState();
  //total km and cable used
  const [overallCount, setOverallCount] = useState();
  //dropdown
  const [selectedDropdownOptions, setSelectedDropdownOptions] = useState(
    dropdownOptions.filter((opt) => opt !== "All")
  );

  const handleChange = (event) => {
    const value = event.target.value;

    if (value.includes("All")) {
      if (selectedDropdownOptions.length === dropdownOptions.length - 1) {
        // All selected → deselect all
        setSelectedDropdownOptions([]);
      } else {
        // Select all except "All" itself
        setSelectedDropdownOptions(
          dropdownOptions.filter((opt) => opt !== "All")
        );
      }
    } else {
      setSelectedDropdownOptions(value);
    }
  };

  //end
  // Add this for Super Admin selection
  const [selectedStaffId, setSelectedStaffId] = useState("");

  // For month/year default (current)
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = String(today.getMonth() + 1).padStart(2, "0");
  const [selectedMonth, setSelectedMonth] = useState(
    `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`
  );
  //count for complaint
  const [complaintCount, setComplaintCount] = useState({
    open: 0,
    completed: 0,
  });
  //count for installation
  const [installationCount, setInstallationCount] = useState({
    open: 0,
    completed: 0,
  });
  //complaint state
  const [complaintsData, setComplaintsData] = useState({
    labels: [],
    datasets: [
      {
        label: "Open",
        data: [1, 2, 3, 4, 5, 6, 7],
        borderColor: "green",
        backgroundColor: "rgba(0, 255, 0, 0.2)",
        pointBorderColor: "black",
        pointBackgroundColor: "black",
        borderWidth: 3,
      },
      {
        label: "Solved",
        data: [1, 2, 3, 4, 5, 6, 7],
        borderColor: "blue",
        backgroundColor: "rgba(0, 0, 255, 0.2)",
        pointBorderColor: "black",
        pointBackgroundColor: "black",
        borderWidth: 3,
      },
    ],
  });
  //installation state
  const [installationData, setInstallationData] = useState({
    labels: [],
    datasets: [],
  });
  const [pieChartData, setPieChartData] = useState({
    totalWorkHr: 0,
    totalExtraHr: 0,
    totalIdleHr: 0,
    avgWork: "0H 0M",
    avgExtra: "0H 0M",
    avgIdle: "0H 0M",
    totalValue: 0,
    hasData: false, // Add a flag to track if data exists
  });

  const {
    totalWorkHr,
    totalExtraHr,
    totalIdleHr,
    avgWork,
    avgExtra,
    avgIdle,
    totalValue,
  } = pieChartData;

  const dataPie = {
    datasets: [
      {
        label: "Work Time",
        data: [totalWorkHr, totalValue - totalWorkHr],
        backgroundColor: ["#195C9A", "#E6E6E6"],
        cutout: "70%",
        circumference: 360,
        rotation: 225,
      },
      {
        label: "Extra Time",
        data: [totalExtraHr, totalValue - totalExtraHr],
        backgroundColor: ["#66E6FF", "#E6E6E6"],
        cutout: "55%",
        circumference: 360,
        rotation: 225,
      },
      {
        label: "Idle Time",
        data: [totalIdleHr, totalValue - totalIdleHr],
        backgroundColor: ["#B87333", "#E6E6E6"],
        cutout: "40%",
        circumference: 360,
        rotation: 225,
      },
    ],
  };

  const optionsPie = {
    responsive: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
  };

  {
    /* Image Viewer State */
  }
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
const [viewerData, setViewerData] = useState(null);
const [installDetails, setinstallDetails] = useState([]);
const [complaintDetails, setcomplaintDetails] = useState([]);



  const openViewer = (images, index, data) => {

    console.log(images)
    setCurrentImages(images.map((img) => img.image));
    setCurrentImage(index);
    setIsViewerOpen(true);
    setImagesDelData(data);
    console.log(data)
    setViewerData(data.parentId)
  };
console.log(viewerData,"viewdata")

 useEffect(() => {
  if (viewerData) {
    console.log("viewerData on useEffect start:", viewerData);

    const fetchData = async () => {
      try {
        // Make sure apiUrl ends WITHOUT a trailing slash if we add one here
        const res = await axios.get(`${apiUrl}/getdata-install-id/${viewerData}`);
        console.log("Fetched data:", res.data);

        setinstallDetails(res.data.message);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }
}, [viewerData]);


 const planMonth = Number(installDetails?.installplanDetails?.installplanMonth) || 0;
  const planAmount = Number(installDetails?.installplanDetails?.installplanAmount) || 0;
  const staticIpCost = Number(installDetails?.installplanDetails?.installstaticIpCost) || 0;
  const installationCost = Number(installDetails?.installplanDetails?.installinstalationCost) || 0;
  const routerCost = Number(installDetails?.installplanDetails?.installrouterCost) || 0;
  const otherCost = Number(installDetails?.installplanDetails?.installothersCost) || 0;

  const totalPlanAmount = planMonth * planAmount;

  const baseAmount = totalPlanAmount + staticIpCost + installationCost + routerCost + otherCost;

  const gstAmount = baseAmount * 0.18;

  const orderValue = +(baseAmount + gstAmount).toFixed(2);


  const formattedOrderValue = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR"
  }).format(orderValue);


   const plan = installDetails.installplanDetails || {};


  const installrouterCost = Number(plan.routerSellingCost) || 0;
  const installfiberCost = Number(plan.installfiberCost) || 0;
  const installfiberCableMeter = Number(plan.installfiberCableMeter) || 0;
  const installottPrice = Array.isArray(plan.installottPrice) ? Number(plan.installottPrice[0]) || 0 : 0;
  const installothersCost = Number(plan.installothersCost) || 0;
  const OrderScore = baseAmount
    - installrouterCost
    - (installfiberCableMeter * installfiberCost)
    - installottPrice
    - installothersCost;

  console.log("OrderScore:", OrderScore);
  console.log(baseAmount, 'baseamout')

  const formattedOrderScore = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR"
  }).format(OrderScore);

  console.log(installDetails)



  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  // const deleteImage = () => {
  //   alert(`Delete image at index ${currentImage}`);
  //   closeViewer();
  // };

  const handleGenerate = async () => {
    const [year, month] = selectedMonth.split("-").map(Number);

    // Use Redux staffId for regular users, selectedStaffId for Super Admin/Admin
    const effectiveStaffId = (role === "Super Admin" || role === "Admin") ? selectedStaffId : staffId;

    if (!selectedMonth || !effectiveStaffId) {
      return;
    }

    try {
      // 1️⃣ First API - Attendance Time Contribution
      const attendanceResponse = await axios.get(
        `${apiUrl}/attendance/monthfilter`,
        {
          params: { staffId: effectiveStaffId, year, month },
        }
      );

      if (attendanceResponse.data.success) {
        const attendanceArray = attendanceResponse.data.data;
        const formattedData = {};
        attendanceArray.forEach((rec) => {
          const day = new Date(rec.date).getDate();
          formattedData[day] = rec;
        });

        const presentCount = Object.keys(formattedData).length;

        const totalWorkMin = Object.values(formattedData).reduce(
          (sum, item) => sum + (item.totalTimeWithoutBreak || 0),
          0
        );
        const totalExtraMin = Object.values(formattedData).reduce(
          (sum, item) => sum + (item.extraTime || 0),
          0
        );
        const totalIdleMin = Object.values(formattedData).reduce(
          (sum, item) => sum + (item.idleTime || 0),
          0
        );

        const totalWorkHr = +(totalWorkMin / 60).toFixed(2);
        const totalExtraHr = +(totalExtraMin / 60).toFixed(2);
        const totalIdleHr = +(totalIdleMin / 60).toFixed(2);

        const avgWork = presentCount
          ? formatToHM(totalWorkMin / presentCount)
          : "0H 0M";
        const avgExtra = presentCount
          ? formatToHM(totalExtraMin / presentCount)
          : "0H 0M";
        const avgIdle = presentCount
          ? formatToHM(totalIdleMin / presentCount)
          : "0H 0M";

        const totalValue = totalWorkHr + totalExtraHr + totalIdleHr;

        setPieChartData({
          totalWorkHr,
          totalExtraHr,
          totalIdleHr,
          avgWork,
          avgExtra,
          avgIdle,
          totalValue,
          hasData: presentCount > 0, // Set to true if there's data
        });
      }

      // 2️⃣ Second API - Complaint Report
      const complaintResponse = await axios.get(
        `${apiUrl}/status-summary/${effectiveStaffId}?year=${year}&month=${month}`
      );

      const summary = complaintResponse.data;
      const labelDays = [1, 5, 10, 15, 20, 25];
      const labels = labelDays.map((day) => {
        const date = new Date(year, month - 1, day);
        const monthAbbr = date
          .toLocaleString("en-US", { month: "short" })
          .toUpperCase();
        return `${monthAbbr} ${String(day).padStart(2, "0")}`;
      });

      const lastDay = new Date(year, month, 0).getDate();
      labels.push(
        `${new Date(year, month - 1)
          .toLocaleString("en-US", { month: "short" })
          .toUpperCase()} ${lastDay}`
      );

      const formatDateMap = (list) =>
        list.reduce((acc, item) => {
          const d = new Date(item.date);
          const label = `${d
            .toLocaleString("en-US", {
              month: "short",
            })
            .toUpperCase()} ${String(d.getDate()).padStart(2, "0")}`;
          acc[label] = item.count;
          return acc;
        }, {});

      const openMap = formatDateMap(summary.open);
      const completedMap = formatDateMap(summary.completed);

      const openData = labels.map((label) => openMap[label] || 0);
      const completedData = labels.map((label) => completedMap[label] || 0);

      setComplaintsData({
        labels,
        datasets: [
          {
            label: "Open",
            data: openData,
            borderColor: "green",
            backgroundColor: "rgba(0, 255, 0, 0.2)",
            pointBorderColor: "black",
            pointBackgroundColor: "black",
            borderWidth: 3,
          },
          {
            label: "Solved",
            data: completedData,
            borderColor: "blue",
            backgroundColor: "rgba(0, 0, 255, 0.2)",
            pointBorderColor: "black",
            pointBackgroundColor: "black",
            borderWidth: 3,
          },
        ],
      });
    } catch (err) {
      console.error("Error in handleGenerate:", err);
    }
  };

  // ⏱ Format Minutes to HH:MM
  const formatToHM = (mins) => {
    const h = Math.floor(mins / 60);
    const m = Math.round(mins % 60);
    return `${h}H ${m}M`;
  };

  // delete image from modal
  const deleteImage = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This image will be permanently deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      customClass: {
        popup: "swal-popup-high-z",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(apiUrl + "team-images/delete", { data: imagesDelData })
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: "Deleted!",
              text: res.data.message,
              timer: 2000,
              showConfirmButton: false,
            });

            // Update the overallImages state
            setOverallImages((prev) => {
              // Create a deep copy of the state
              const updatedImages = JSON.parse(JSON.stringify(prev));

              // Find and remove the deleted image from the appropriate category
              Object.keys(updatedImages).forEach((category) => {
                if (category === "complaint" || category === "recovery") {
                  if (updatedImages[category]?.images) {
                    updatedImages[category].images = updatedImages[
                      category
                    ].images.filter((img) => img._id !== imagesDelData.imageId);
                    updatedImages[category].count =
                      updatedImages[category].images.length;
                  }
                } else if (
                  category === "fiberTeam" ||
                  category === "networkTeam"
                ) {
                  Object.keys(updatedImages[category]).forEach((subtype) => {
                    if (updatedImages[category][subtype]?.images) {
                      updatedImages[category][subtype].images = updatedImages[
                        category
                      ][subtype].images.filter(
                        (img) => img._id !== imagesDelData.imageId
                      );
                      updatedImages[category][subtype].count =
                        updatedImages[category][subtype].images.length;
                    }
                  });
                }
              });

              return updatedImages;
            });

            // Close the viewer
            closeViewer();
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: err.response?.data?.error || "Failed to delete image.",
            });
          });
      }
    });
  };

console.log(overallImages,"overallaimabbjwe")


  useEffect(() => {
    handleGenerate();
  }, []);
  //complaint useffect
  useEffect(() => {
    const generateLabels = (monthStr) => {
      const [year, month] = monthStr.split("-").map(Number);
      const labelDays = [1, 5, 10, 15, 20, 25];

      const labels = labelDays.map((day) => {
        const date = new Date(year, month - 1, day);
        const monthAbbr = date
          .toLocaleString("en-US", { month: "short" })
          .toUpperCase();
        return `${monthAbbr} ${String(day).padStart(2, "0")}`;
      });

      const lastDay = new Date(year, month, 0).getDate();
      labels.push(
        `${new Date(year, month - 1)
          .toLocaleString("en-US", {
            month: "short",
          })
          .toUpperCase()} ${lastDay}`
      );

      return labels;
    };

    const updatedLabels = generateLabels(selectedMonth);

    setComplaintsData((prevData) => ({
      ...prevData,
      labels: updatedLabels,
    }));
  }, [selectedMonth]);
  //installaton useeffect
  useEffect(() => {
    const generateLabels = (monthStr) => {
      const [year, month] = monthStr.split("-").map(Number);
      const labelDays = [1, 5, 10, 15, 20, 25];

      const labels = labelDays.map((day) => {
        const date = new Date(year, month - 1, day);
        const monthAbbr = date
          .toLocaleString("en-US", { month: "short" })
          .toUpperCase();
        return `${monthAbbr} ${String(day).padStart(2, "0")}`;
      });

      const lastDay = new Date(year, month, 0).getDate();
      labels.push(
        `${new Date(year, month - 1)
          .toLocaleString("en-US", { month: "short" })
          .toUpperCase()} ${lastDay}`
      );

      return labels;
    };

    const updatedLabels = generateLabels(selectedMonth);

    setInstallationData((prevData) => ({
      ...prevData,
      labels: updatedLabels,
    }));
  }, [selectedMonth]);
  //fetch KM traveled and cable used
  useEffect(() => {
    const effectiveStaffId = (role === "Super Admin" || role === "Admin") ? selectedStaffId : staffId;
    if (!selectedMonth || !effectiveStaffId) return;

    const [year, month] = selectedMonth.split("-");

    axios
      .get(`${apiUrl}work-summary/${effectiveStaffId}`, {
        params: {
          year: year,
          month: month,
        },
      })
      .then((res) => {
        setOverallCount(res.data);
      })
      .catch((error) => {
        console.error("Error fetching work summary:", error);
      });
  }, [selectedMonth, staffId, selectedStaffId, role]);
  //fetch images
  useEffect(() => {
    const effectiveStaffId = (role === "Super Admin" || role === "Admin") ? selectedStaffId : staffId;
    if (!selectedMonth || !effectiveStaffId) return;

    const [year, month] = selectedMonth.split("-");

    axios
      .get(`${apiUrl}team-images`, {
        // Remove the /${staffId} from URL
        params: {
          staffId: effectiveStaffId,
          year: year,
          month: month,
        },
      })
      .then((res) => {
        setOverallImages(res.data);
        console.log(res.data);
      })
      .catch((error) => {
        console.error("Error fetching team images:", error);
      });
  }, [selectedMonth, staffId, selectedStaffId, role]);

  console.log(overallImages,"overala Images")
  // Fetch complaint summary data
  useEffect(() => {
    const fetchStatusSummary = async () => {
      const effectiveStaffId = (role === "Super Admin" || role === "Admin") ? selectedStaffId : staffId;
      if (!effectiveStaffId) return;
      try {
        const [year, month] = selectedMonth.split("-");
        const response = await axios.get(
          `${apiUrl}status-summary/${effectiveStaffId}?year=${year}&month=${month}`
        );

        const summary = response.data;
        const yearInt = parseInt(year);
        const monthInt = parseInt(month) - 1;

        // Get the last day of the month (28, 29, 30, or 31)
        const lastDay = new Date(yearInt, monthInt + 1, 0).getDate();

        // Generate labels for ALL days in the month
        const labels = Array.from({ length: lastDay }, (_, i) => {
          const day = i + 1;
          const date = new Date(yearInt, monthInt, day);
          const monthAbbr = date
            .toLocaleString("en-US", { month: "short" })
            .toUpperCase();
          return `${monthAbbr} ${String(day).padStart(2, "0")}`;
        });

        // Format the data to map dates to counts (using day number as key)
        const formatDateMap = (list) =>
          list.reduce((acc, item) => {
            const d = new Date(item.date);
            const day = d.getDate(); // Get day number (1-31)
            acc[day] = item.count; // Use day number as key
            return acc;
          }, {});

        const generateChartData = (title, color1, color2, data) => {
          const openMap = formatDateMap(data.open || []);
          const completedMap = formatDateMap(data.completed || []);

          // Create data arrays for ALL days in the month
          const openData = Array.from({ length: lastDay }, (_, i) => {
            return openMap[i + 1] || 0; // i+1 because days start from 1
          });

          const completedData = Array.from({ length: lastDay }, (_, i) => {
            return completedMap[i + 1] || 0;
          });

          return {
            labels,
            datasets: [
              {
                label: "Open",
                data: openData,
                borderColor: color1,
                backgroundColor: `${color1}33`,
                pointBorderColor: "black",
                pointBackgroundColor: "black",
                borderWidth: 3,
              },
              {
                label: "Completed",
                data: completedData,
                borderColor: color2,
                backgroundColor: `${color2}33`,
                pointBorderColor: "black",
                pointBackgroundColor: "black",
                borderWidth: 3,
              },
            ],
          };
        };

        // Set chart data
        setComplaintsData(
          generateChartData("Complaint", "#1fbd61ff",
            "#0497FF", summary.complaint)
        );
        setInstallationData(
          generateChartData(
            "Installation",
            "#1fbd61ff",
            "#F1C40F",
            summary.installation
          )
        );

        // Set total counts (unchanged)
        const getTotalCount = (list = []) =>
          list.reduce((total, item) => total + item.count, 0);

        setComplaintCount({
          open: getTotalCount(summary.complaint?.open),
          completed: getTotalCount(summary.complaint?.completed),
        });

        setInstallationCount({
          open: getTotalCount(summary.installation?.open),
          completed: getTotalCount(summary.installation?.completed),
        });
      } catch (error) {
        console.error("Failed to fetch status summary:", error);
      }
    };

    const effectiveStaffId = (role === "Super Admin" || role === "Admin") ? selectedStaffId : staffId;
    if (selectedMonth && effectiveStaffId) {
      fetchStatusSummary();
    }
  }, [selectedMonth, staffId, selectedStaffId, role, apiUrl]);
  //image

  // useEffect(() => {
  //   if (!staffId) return;

  //   const fetchImages = async () => {
  //     try {
  //       setLoading(true);
  //       const response = await axios.get(`${apiUrl}message-image/${staffId}`);
  //       setImages(response.data);

  //       console.log(response.data);

  //     } catch (err) {
  //       setError(err.response?.data?.message || "Failed to fetch images");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchImages();
  // }, [staffId]);
  //useeffect to fetch the staffname

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const res = await axios.get(`${apiUrl}/get-staff-names`);
        const staffList = res.data.message
          .filter((s) => s.staffName && s._id)
          .map((s) => ({
            name: s.staffName,
            id: s._id,
          }));

        setStaffName(staffList); // ⬅️ stored in state
      } catch (err) {
        console.error("Error fetching staff names:", err);
      }
    };

    fetchStaff();
  }, []);
  useEffect(() => {
    if ((role === "Super Admin" || role === "Admin") && staffName.length > 0 && !selectedStaffId) {
      setSelectedStaffId(staffName[0].id);
    }
  }, [staffName, role, selectedStaffId]);
  // useEffect(() => {
  //   if (role === "Super Admin" && staffName.length > 0) {
  //     const defaultStaffId = staffName[0].id;
  //     setSelectedValues([defaultStaffId]);
  //     setTimeout(() => {
  //       handleGenerate(); // ✅ Call after setting staff
  //     }, 100);
  //   }
  // }, [staffName]);

  return (
    <div>
      <Topbar />
      <div className="container-fluid">
        <Row>
          <h3>Staff analysis</h3>
        </Row>
        <Row className="mt-3">
          <Col md={2} sm={12}>
            {(role === "Super Admin" || role === "Admin") && (
              <select
                className="attendance-date"
                value={selectedStaffId}
                onChange={(e) => setSelectedStaffId(e.target.value)}
                style={{ backgroundColor: "#EEF7FF" }}
              >
                <option value="">Select Staff</option>
                {staffName.map((staff) => (
                  <option key={staff.id} value={staff.id}>
                    {staff.name}
                  </option>
                ))}
              </select>
            )}
          </Col>
          <Col md={3} sm={12}>
            <div>
              <FormControl sx={{ width: 200 }}>
                <InputLabel id="multi-select-label">Select Options</InputLabel>
                <Select
                  labelId="multi-select-label"
                  multiple
                  displayEmpty
                  value={selectedDropdownOptions}
                  onChange={handleChange}
                  renderValue={(selected) =>
                    selected.length === dropdownOptions.length - 1
                      ? "All options selected"
                      : selected.join(", ")
                  }
                  sx={{
                    "& .MuiSelect-select": {
                      paddingY: 1.5, // reduces vertical padding
                      //  minHeight: "5px", // sets minimum height
                      display: "flex",
                      alignItems: "center",
                    },
                  }}
                >
                  {dropdownOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      <Checkbox
                        checked={
                          option === "All"
                            ? selectedDropdownOptions.length ===
                              dropdownOptions.length - 1
                            : selectedDropdownOptions.includes(option)
                        }
                      />
                      <ListItemText primary={option} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </Col>

          <Col md={2} sm={12}>
            <input
              type="month"
              className="form-control attendance-date"
              value={selectedMonth}
              onChange={(e) => {
                const value = e.target.value;
                if (!value) {
                  // If cleared, reset to current month
                  const current = new Date().toISOString().slice(0, 7);
                  setSelectedMonth(current);
                } else {
                  setSelectedMonth(value);
                }
              }}
            />
          </Col>
          <Col md={4} sm={12}>
            <div className="staff-generate">
              <button className="staff-generate-btn" onClick={handleGenerate}>
                Generate
              </button>
            </div>
          </Col>
        </Row>
        <Row>
          <div className="sa-box mt-5">
            <Row className="">
              <Col md={6} sm={12}>
                <h4>
                  {staffName.find(
                    (s) =>
                      s.id ===
                      ((role === "Super Admin" || role === "Admin")
                        ? selectedStaffId
                        : staffId)
                  )?.name || "Loading..."}
                </h4>
              </Col>
              <Col md={6} sm={12}>
                {/* <button className="black-btn" style={{ float: "right" }}>
                  Export
                </button> */}
              </Col>
            </Row>
            <Row className="mt-4">
              {selectedDropdownOptions.includes("Complaints") && (
                <Col md={7} sm={12}>
                  <div className="sa-linechart-box">
                    <Row>
                      <Col md={5}>
                        <h4>Complaints Report</h4>
                      </Col>
                      <Col md={7}>
                        {" "}
                        <div
                          style={{
                            textAlign: "center",
                            fontSize: "18px",
                            marginTop: 10,
                          }}
                        >
                          <span style={{ color: "#1fbd61ff",
            fontWeight: "bold" }}>
                            Open: {complaintCount.open}
                          </span>{" "}
                          &nbsp;&nbsp;
                          <span style={{ color: "#0497FF", fontWeight: "bold" }}>
                            Completed: {complaintCount.completed}
                          </span>
                        </div>
                      </Col>
                    </Row>

                    <Line data={complaintsData} options={options} />
                  </div>
                </Col>
              )}
              {selectedDropdownOptions.includes("Time Contributions") && (
                <Col md={5} sm={12}>
                  <div className="sa-piechart-box">
                    <Row>
                      <Col md={7} sm={12}>
                        <h4>Time Contributions</h4>
                      </Col>
                      <Col md={5} sm={12}>
                        <p>
                          WT Avg/D : <b>{avgWork}</b>
                        </p>
                        <p>
                          ET Avg/D : <b>{avgExtra}</b>
                        </p>
                        <p>
                          IT Avg/D : <b>{avgIdle}</b>
                        </p>
                      </Col>
                    </Row>
                    <Row className="mt-1">
                      <Col md={9} sm={12}>
                        {pieChartData.hasData ? (
                          <Doughnut
                            data={dataPie}
                            options={optionsPie}
                            width={250}
                            height={250}
                          />
                        ) : (
                          <div
                            style={{
                              width: 250,
                              height: 250,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "7px double #ccc",
                              borderRadius: "50%",
                            }}
                          >
                            <p style={{ textAlign: "center" }}>
                              No data available
                            </p>
                          </div>
                        )}
                      </Col>
                      <Col md={3} sm={12}>
                        <p>
                          <span class="dot sa-darkblue"></span>Work Time
                        </p>
                        <p>
                          <b>{totalWorkHr} H</b>
                        </p>
                        <p>
                          <span class="dot sa-skyblue"></span>Extra Time
                        </p>
                        <p>
                          <b>{totalExtraHr}H </b>
                        </p>
                        <p>
                          <span class="dot sa-brown"></span>Idle Time
                        </p>
                        <p>
                          <b>{totalIdleHr}H</b>
                        </p>
                      </Col>
                    </Row>
                  </div>
                </Col>
              )}
            </Row>
            {/* //graph2------------------------------------------------- */}
            <Row className="mt-4">
              {(selectedDropdownOptions.includes("K M Traveled") ||
                selectedDropdownOptions.includes("Cable Used")) && (
                <Col md={5} sm={12}>
                  <div className="sa-piechart-box">
                    {selectedDropdownOptions.includes("K M Traveled") && (
                      <Row>
                        <div className="sa-piechart-box">
                          <Row className="d-flex">
                            <Col> KM Traveled</Col>
                            <Col>
                              Avg/D:{" "}
                              {overallCount?.totalKmTraveled
                                ? (overallCount.totalKmTraveled / 30).toFixed(1)
                                : "0:0"}
                              KM
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <div>
                              {" "}
                              <span class="dot sa-purple"></span>Total KM
                              Traveled :
                              <strong> {overallCount?.totalKmTraveled}</strong>{" "}
                            </div>
                            <div>
                              {" "}
                              <span class="dot sa-pink"></span>Own Bike :
                              <strong> {overallCount?.ownBike}</strong>
                            </div>
                          </Row>
                        </div>
                      </Row>
                    )}

                    {selectedDropdownOptions.includes("Cable Used") && (
                      <Row>
                        <div className="sa-piechart-box mt-3">
                          <Row className="d-flex">
                            <Col>Cable Used</Col>
                            <Col>
                              Avg/D :{" "}
                              {overallCount?.individualCableUsed
                                ? (
                                    overallCount.individualCableUsed / 30
                                  ).toFixed(1)
                                : "0.0"}
                              KM
                            </Col>
                          </Row>
                          <Row className="mt-3">
                            <div>
                              {" "}
                              <span class="dot sa-purple"></span>Combined Cable
                              Used :
                              <strong>
                                {" "}
                                {overallCount?.combinedCableUsed}{" "}
                              </strong>{" "}
                            </div>
                            <div>
                              {" "}
                              <span class="dot sa-pink"></span>Individual Cable
                              Used :
                              <strong>
                                {" "}
                                {overallCount?.individualCableUsed}
                              </strong>
                            </div>
                          </Row>
                        </div>
                      </Row>
                    )}
                  </div>{" "}
                </Col>
              )}
              {selectedDropdownOptions.includes("Connections") && (
                <Col md={7} sm={12}>
                  <div className="sa-linechart-box">
                    <h4>Connection Report</h4>
                    <Line data={installationData} options={options} />
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "18px",
                        marginTop: 10,
                      }}
                    >
                      <span style={{ color: "#1fbd61ff", fontWeight: "bold" }}>
                        Open: {installationCount.open}
                      </span>{" "}
                      &nbsp;&nbsp;
                      <span style={{ color: "#F1C40F", fontWeight: "bold" }}>
                        Completed: {installationCount.completed}
                      </span>
                    </div>
                  </div>
                </Col>
              )}
            </Row>
          </div>
        </Row>
        {/* image box 1------------------------------------------------------------ */}
        <div className="mt-5">
          {/* Fiber Team Section - Only show if there are any fiber team images */}
          {selectedDropdownOptions.includes("Fiber Team Photos") &&
            overallImages?.fiberTeam &&
            Object.values(overallImages.fiberTeam).some(
              (data) => data.count > 0
            ) && (
              <div className="team-section">
                {Object.entries(overallImages.fiberTeam).map(
                  ([subtype, data]) =>
                    data.count > 0 && (
                      <div key={`fiber-${subtype}`} className="subtype-row">
                        <h4>
                          {subtype.charAt(0).toUpperCase() + subtype.slice(1)} (
                          {data.count})
                        </h4>
                        <Row>
                          {data.images.map((img, index) => (
                            <Col
                              key={`fiber-${subtype}-${index}`}
                              xs={12}
                              sm={6}
                              md={4}
                              lg={3}
                            >
                              <div className="image-container">
                                <img
                                  src={img.image}
                                  alt={`${subtype} by ${img.staffName}`}
                                  style={{
                                    width: "100%",
                                    height: "200px",
                                    objectFit: "cover",
                                    marginBottom: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    let values = {
                                      imageUrl: img.image,
                                      parentId: img.parentId,
                                      type: img.type,
                                      imageId: img._id,
                                    };

                                    openViewer(data.images, index, values);
                                  }}
                                />
                                <p className="image-caption">
                                  {/* By {img.staffName} •{" "} */}
                                  {new Date(img.date).toLocaleDateString()}
                                </p>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    )
                )}
              </div>
            )}

          {/* Network Team Section - Only show if there are any network team images */}
          {selectedDropdownOptions.includes("Network Team Photos") &&
            overallImages?.networkTeam &&
            Object.values(overallImages.networkTeam).some(
              (data) => data.count > 0
            ) && (
              <div className="team-section">
                {Object.entries(overallImages.networkTeam).map(
                  ([subtype, data]) =>
                    data.count > 0 && (
                      <div key={`network-${subtype}`} className="subtype-row">
                        <h4>
                          {subtype.charAt(0).toUpperCase() + subtype.slice(1)} (
                          {data.count})
                        </h4>
                        <Row>
                          {data.images.map((img, index) => (
                            <Col
                              key={`network-${subtype}-${index}`}
                              xs={12}
                              sm={6}
                              md={4}
                              lg={3}
                            >
                              <div className="image-container">
                                <img
                                  src={img.image}
                                  alt={`${subtype} by ${img.staffName}`}
                                  style={{
                                    width: "100%",
                                    height: "200px",
                                    objectFit: "cover",
                                    marginBottom: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    let values = {
                                      imageUrl: img.image,
                                      parentId: img.parentId,
                                      type: img.type,
                                      imageId: img._id,
                                    };
                                    openViewer(data.images, index, values);
                                  }}
                                />
                                <p className="image-caption">
                                  {/* By {img.staffName} •{" "} */}
                                  {new Date(img.date).toLocaleDateString()}
                                </p>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    )
                )}
              </div>
            )}

          {/* Complaint Section - Only show if there are complaint images */}

          {selectedDropdownOptions.includes("Complaints Photos") &&
            overallImages?.complaint?.count > 0 && (
              <div className="team-section">
                <h3>Complaint ({overallImages.complaint.count})</h3>
                <Row>
                  {overallImages.complaint.images.map((img, index) => (
                    <Col
                      key={`complaint-${index}`}
                      xs={12}
                      sm={6}
                      md={4}
                      lg={3}
                    >
                      <div className="image-container">
                        <img
                          src={img.image}
                          alt={`Complaint by ${img.staffName}`}
                          style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "cover",
                            marginBottom: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            let values = {
                              imageUrl: img.image,
                              parentId: img.parentId,
                              type: img.type,
                              imageId: img._id,
                            };
                            openViewer(
                              overallImages.complaint.images,
                              index,
                              values
                            );
                          }}
                        />
                        <p className="image-caption">
                          {/* By {img.staffName} •{" "} */}
                          {new Date(img.date).toLocaleDateString()}
                        </p>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            )}


          {/* Recovery Section - Only show if there are recovery images */}
          {selectedDropdownOptions.includes("Recovery Photos") &&
            overallImages?.recovery?.count > 0 && (
              <div className="team-section">
                <h3>Recovery ({overallImages.recovery.count})</h3>
                <Row>
                  {overallImages.recovery.images.map((img, index) => (
                    <Col key={`recovery-${index}`} xs={12} sm={6} md={4} lg={3}>
                      <div className="image-container">
                        <img
                          src={img.image}
                          alt={`Recovery by ${img.staffName}`}
                          style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "cover",
                            marginBottom: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            let values = {
                              imageUrl: img.image,
                              parentId: img.parentId,
                              type: img.type,
                              imageId: img._id,
                            };
                            openViewer(
                              overallImages.recovery.images,
                              index,
                              values
                            );
                          }}
                        />
                        <p className="image-caption">
                          {/* By {img.staffName} •{" "} */}
                          {new Date(img.date).toLocaleDateString()}
                        </p>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            )}

          {/* Image Viewer - Single instance for all images */}
          {isViewerOpen && (
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
              }}
            >
              <ImageViewer
                src={currentImages}
                currentIndex={currentImage}
                disableScroll={false}
                closeOnClickOutside={true}
                onClose={closeViewer}
                backgroundStyle={{ backgroundColor: "rgba(0,0,0,0.9)" }}
              />

  <div
  style={{
    position: "fixed",
    top: "20px",
    left: "50%",              // Start from middle
    transform: "translateX(-50%)", // Shift back half width → perfectly center
    width: "70%",             // 70% of screen
    zIndex: 10000,
    padding: "0 15px",
  }}
>
  <Row className="align-items-center">

{/* Left column */}

  <Col md={8} xs={8} className="text-start">
  {(imagesDelData.type !=="complaint"  && imagesDelData.type!=="recovery")
&& (
    <div className="plan-details-container-border-staff-analysis bg-white text-black mt-3 text-center">
      <p style={{ fontSize: "13px" }} className="pt-2">
        <span className="text-primary">
          {installDetails?.installplanDetails?.installfiberCableMeter}
        </span>{" "}
        M,{" "}
        <span className="text-primary">
          {installDetails?.installplanDetails?.installplanSpeed}
        </span>{" "}
        Mbps,{" "}
        <span className="text-primary">
          {installDetails?.installplanDetails?.installplanMonth}
        </span>
        Month @{" "}
        <span className="text-primary">
          Rs. {installDetails?.installplanDetails?.installplanAmount}/-
        </span>
      </p>
      <p style={{ fontSize: "13px" }}>
        Order Value @{" "}
        <span className="text-primary">Rs.{formattedOrderValue}/-</span>, OrderScore @{" "}
        <span className="text-primary">Rs.{formattedOrderScore}/-</span>
      </p>
    </div>
    )}
  </Col>




    {/* Right column */}
    <Col md={4} xs={4} className="text-end">
      <button
        onClick={(e) => {
          e.stopPropagation(); // prevent ImageViewer from closing
          deleteImage();
        }}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          backgroundColor: "#e74c3c",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Delete
      </button>
    </Col>
  </Row>
</div>


              <div
                style={{
                  position: "fixed",
                  bottom: "30px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  color: "white",
                  fontSize: "18px",
                  zIndex: 10000,
                }}
              >
                {/* Image {currentImage + 1} of {currentImages.length} */}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
